import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams, Outlet, Link } from "react-router-dom";
import { Menu, ConfigProvider, Dropdown, Space, Button, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import api from "@/api";
import { findDeep, getRulesDetail, format } from "@/utils";
import { publicPath } from "@/utils/base";

import dataJson from "@/../public/data.json";

const prefix = "rulesDetail";
import "./index.less";
import { cloneDeep } from "lodash-es";

function RulesDetail() {
  const { add, rules_detail, release, req_err } = dataJson;
  const [current, setCurrent] = useState("");
  const [dropdownItems, setDropdownItems] = useState<any[]>([]);
  const [rulesList, setRulesList] = useState<any[]>([]);
  const [dropdownSelect, setDropdownSelect] = useState("");
  const [isAddVersion, setIsAddVersion] = useState<boolean>(true);

  const rulesDetail = useSelector((state: any) => state.rulesDetail);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { id } = useParams();

  const onClick = (e: any) => {
    if (current === e.key) {
      return;
    }
    setCurrent(e.key);
    if (e.key === "versionmanage") {
      getRulesDetail(rulesDetail?.histories[0].id, () => {
        navigate(`${publicPath}${e.item.props.url}/${rulesDetail?.histories[0].id}`);
      });
    } else {
      getRulesDetail(rulesDetail?.currentId, () => {
        navigate(`${publicPath}${e.item.props.url}/${rulesDetail.currentId}`);
      });
    }
  };

  const dropdownOnClick = (e: any) => {
    setDropdownSelect(e.key);
    navigate(`${publicPath}/rules_detail/versionmanage/${e.key}`);
  };

  const upgrade = async () => {
    const firstShowMode = findDeep(release.show_mode_arr, rulesDetail?.histories[0]?.showMode);
    if (rulesDetail?.histories?.length > 1 && firstShowMode.isUpgrade) {
      navigate(`${publicPath}/rules_detail/versionmanage/${rulesDetail?.histories[0].id}`);
      getRulesDetail(rulesDetail?.histories[0].id);
    } else {
      try {
        const res: any = await api.upgradeVersionRuleApi({ id: rulesDetail?.currentId });
        if (res?.code == 200) {
          navigate(`${publicPath}/rules_detail/versionmanage/${res.data.id}`);
          getRulesDetail(res.data.id);
        } else {
          message.error(res.msg);
        }
      } catch (errorInfo: any) {
        message.error(errorInfo?.response?.data?.msg || req_err);
        return;
      }
    }
  };

  const getRulesList = async () => {
    try {
      const res: any = await api.getAllNoPage({
        typeKeys:['RULE_ENGINE']
      });
      if (res.code === 200) {
        const pathnameArr = window.location.pathname.split("/");
        const basePathname = pathnameArr.slice(0, pathnameArr.length - 1).join("/");

        const dataCopy = cloneDeep(res.data);
        const list = dataCopy.map((item: any) => {
          return {
            key: item.id,
            label: <Link to={`${basePathname}/${item.firstAppId}`}>{item.name}</Link>,
          };
        });

        setRulesList(list || []);
      } else {
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
    }
  };

  useEffect(() => {
    if (rulesDetail) {
      const resData = cloneDeep(rulesDetail);
      const resShowMode = findDeep(release.show_mode_arr, resData?.showMode);
      // const firstShowMode = findDeep(release.show_mode_arr, rulesDetail?.histories[0]?.showMode);
      // 有升级场景，在新版本页面，按钮要受到旧版本状态影响
      if (resShowMode?.isUpgrade && resData?.histories?.length > 1) {
        const oldShowMode = resData?.histories[1]?.showMode;
        resData.baseBtns = resShowMode?.btnsByOld[oldShowMode];
      } else {
        resData.baseBtns = resShowMode?.baseBtns;
      }
      // if (resData?.showMode === "HISTORY" || (firstShowMode?.isUpgrade && resData.id !== firstShowMode?.id)) {
      //   setIsAddVersion(false);
      // } else {
      setIsAddVersion(!resData.baseBtns?.includes("upgrade"));
      // }

      getRulesList();

      const newDropdownItems: any[] = rulesDetail?.histories?.map((item: any) => {
        const showModeItem = findDeep(release.show_mode_arr, item?.showMode);
        return {
          key: item.id,
          label: (
            <div className={`${prefix}-dropdownItems`}>
              <div className={`${prefix}-dropdownItems-version one-line-ellipsis`} title={item.version}>
                {item?.version ? (
                  <div className={`${prefix}-dropdownItems-version-text`}>
                    {rules_detail.version_v}
                    {item.version}
                  </div>
                ) : (
                  <div className={`${prefix}-dropdownItems-version-text`}>{rules_detail.new_version}</div>
                )}
                <div className={`${prefix}-dropdownItems-version-status`} style={{ color: showModeItem.textColor }}>
                  {showModeItem.title}
                </div>
              </div>
              <div className={`${prefix}-dropdownItems-time`}>
                {format(new Date(Number(item.createTime)), "yy年MM月dd日 HH:mm")}
              </div>
            </div>
          ),
        };
      });
      setDropdownItems(newDropdownItems || []);
    }
  }, [rulesDetail]);

  useEffect(() => {
    const pathArr = pathname.split("/");
    setCurrent(pathArr[pathArr.length - 2]);
    setDropdownSelect(id || "");
    // getRulesDetail(id);
  }, [pathname]);
  return (
    <div className={prefix}>
      <div className={`${prefix}-menu-wrap`}>
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                itemSelectedBg: "#0A59F7",
                itemSelectedColor: "#fff",
                itemBorderRadius: 0,
                iconSize: 14,
                itemHeight: 64,
                fontSize: 18,
              },
            },
          }}
        >
          <Menu
            onClick={onClick}
            mode="inline"
            items={rules_detail.menu}
            defaultOpenKeys={["distribute"]}
            selectedKeys={[current]}
            className={`${prefix}-menu`}
          />
        </ConfigProvider>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Button: { colorPrimary: "#0A59F7" },
            Tabs: { colorPrimary: "#0A59F7" },
          },
        }}
      >
        <div className={`${prefix}-top`}>
          <div className={`${prefix}-breadCrumb`}>
            <Link to={`${publicPath}/staging`} state={{ tabKey: "2" }} className={`${prefix}-breadCrumb-link`}>
              {rules_detail.detail_title}
            </Link>
            &nbsp;/&nbsp;
            <Link to={`${publicPath}/rules_list`} className={`${prefix}-breadCrumb-link`}>
              {rules_detail.my_rules}
            </Link>
            &nbsp;/&nbsp;
            <Dropdown menu={{ items: rulesList, style: { maxHeight: "70vh" } }}>
              <Space style={{ color: "#1A1A1A" }}>
                {rulesDetail?.name}
                <DownOutlined />
              </Space>
            </Dropdown>
          </div>
          {current === "versionmanage" ? (
            <div className={`${prefix}-top-right`}>
              <Button type="link" disabled={isAddVersion} onClick={upgrade}>
                {add + rules_detail.version}
              </Button>
              <Dropdown
                menu={{
                  items: dropdownItems,
                  selectable: true,
                  selectedKeys: [dropdownSelect],
                  onClick: dropdownOnClick,
                }}
                overlayClassName={`${prefix}-dropdown-overlay`}
              >
                <span className={`${prefix}-dropdown`}>
                  <Space>
                    {rules_detail.version}
                    <DownOutlined />
                  </Space>
                </span>
              </Dropdown>
            </div>
          ) : (
            <span></span>
          )}
        </div>

        <Outlet />
      </ConfigProvider>
    </div>
  );
}

export default RulesDetail;
